// extracted by mini-css-extract-plugin
export default {"wrapper":"F1-z","play":"G1-z"};